export const TV_PARALLAX = {
  default: { magnification: 1.02 },
  prominent: { magnification: 1.05 },
  none: { enabled: false },
} as const;
